import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { handleChangeDataAddCourierPage } from '../../../../redux/actions/pages/couriers/add';
import { handleSetOpenCustomSnackbar } from '../../../../redux/actions/snackbar';
import { handleSetBackdropLoading } from '../../../../redux/actions/loaders';
import { API_REGISTER_COURIERS } from '../../../../apis';
import apiRequest from '../../../../utils/apiRequest'; 
import { Row, Col } from 'react-bootstrap';
import Collapse from '@mui/material/Collapse';


const AddCourier = () => {

	const dispatch = useDispatch();
    const navigate = useNavigate();


	const { token } = useSelector(state => state.login);
    const { isBackdropLoading } = useSelector(state => state.allLoaders);
    const { fname, lname, mobile, national_code, phone, vehicle_model, plate, status } = useSelector(state => state.addCourier);
    

    useEffect(() => {
        setBoxCollapsed(true);
        // eslint-disable-next-line
    }, []);



    const [isHeadingElementsVisible, setIsHeadingElementsVisible] = useState(false);
    const [boxCollapsed, setBoxCollapsed] = React.useState(false);
    const handleBoxCollapsed = () => {
        setBoxCollapsed((prev) => !prev);
    };



    const handleSubmitForm = (event) => {
        if(event !== undefined)
            event.preventDefault();


        if(! isBackdropLoading) {
            apiRequest({
                dispatch,
                endpoint: API_REGISTER_COURIERS,
                method: 'post',
                token: token,
                data: {fname, lname, mobile, national_code, phone, vehicle_model, plate, status: (status === "فعال" ? "1" : '0')},
                successMessage: 'پیک جدید با موفقیت ثبت شد',
                onSuccess: (res) => {
                    dispatch(handleChangeDataAddCourierPage('fname', ''));
                    dispatch(handleChangeDataAddCourierPage('lname', ''));
                    dispatch(handleChangeDataAddCourierPage('mobile', ''));
                    dispatch(handleChangeDataAddCourierPage('national_code', ''));
                    dispatch(handleChangeDataAddCourierPage('phone', ''));
                    dispatch(handleChangeDataAddCourierPage('vehicle_model', ''));
                    dispatch(handleChangeDataAddCourierPage('plate', ''));
                    dispatch(handleChangeDataAddCourierPage('status', 'فعال'));

                    navigate(-1);
                },
            });
        }

    };




    const handleChangeInputs = (event) => {
        const {name, value} = event.target;
        dispatch(handleChangeDataAddCourierPage(name, value));
    };



    return (
		<div className="app-content content container-fluid">
            <div className="content-wrapper">
                <div className="content-header row">
                </div>
                <div className="content-body">




                    <Row>
                        <Col className="col-xs-12">
                            <div className="card" style={{minHeight: 'unset !important'}} >
                                <div className="card-header">
                                    <h4 className="card-title">ثبت پیک جدید</h4>
                                    <a className="heading-elements-toggle" onClick={() => setIsHeadingElementsVisible(! isHeadingElementsVisible)}><i className="icon-ellipsis font-medium-3"></i></a>
                                    <div className={`heading-elements ${isHeadingElementsVisible ? 'visible' : ''}`}>
                                        <ul className="list-inline mb-0">
                                            <li><a data-action="collapse"><i className={boxCollapsed ? "icon-minus4" : "icon-plus4"} onClick={handleBoxCollapsed}></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                                

                                <Collapse in={boxCollapsed} className="card-body collapse in">
                                    <div className="card-block">
                                        <div className="form-body" style={{overflow: 'unset !important'}} >
                                            <Row >
                                                <div class="form-group col-md-3">
                                                    <label class="c-label">نام</label>
                                                    <input name="fname" type="text" class="form-control" id="" value={fname} onChange={handleChangeInputs} placeholder="" style={{height: "40px"}} />
                                                    <p class="text-danger"></p>
                                                </div>
                                                <div class="form-group col-md-3">
                                                    <label class="c-label">نام خانوادگی</label>
                                                    <input name="lname" type="text" class="form-control" id="" value={lname} onChange={handleChangeInputs} placeholder="" style={{height: "40px"}} />
                                                    <p class="text-danger"></p>
                                                </div>
                                                <div class="form-group col-md-3">
                                                    <label class="c-label">موبایل</label>
                                                    <input name="mobile" type="text" class="form-control" id="" value={mobile} onChange={handleChangeInputs} placeholder="" style={{height: "40px"}} />
                                                    <p class="text-danger"></p>
                                                </div>
                                                <div class="form-group col-md-3">
                                                    <label class="c-label">کدملی</label>
                                                    <input name="national_code" type="text" class="form-control" id="" value={national_code} onChange={handleChangeInputs} placeholder="" style={{height: "40px"}} />
                                                    <p class="text-danger"></p>
                                                </div>
                                            </Row>

                                            <Row >
                                                <div class="form-group col-md-3">
                                                    <label class="c-label">تلفن ثابت</label>
                                                    <input name="phone" type="text" class="form-control" id="" value={phone} onChange={handleChangeInputs} placeholder="" style={{height: "40px"}} />
                                                    <p class="text-danger"></p>
                                                </div>
                                                <div class="form-group col-md-3">
                                                    <label class="c-label">وسیله نقلیه</label>
                                                    <input name="vehicle_model" type="text" class="form-control" id="" value={vehicle_model} onChange={handleChangeInputs} placeholder="مثلا پراید سفید" style={{height: "40px"}} />
                                                    <p class="text-danger"></p>
                                                </div>
                                                <div class="form-group col-md-3">
                                                    <label class="c-label">پلاک وسیله نقلیه</label>
                                                    <input name="plate" type="text" class="form-control" id="" value={plate} onChange={handleChangeInputs} placeholder="" style={{height: "40px"}} />
                                                    <p class="text-danger"></p>
                                                </div>
                                                <div class="form-group col-md-3">
                                                    <label class="c-label">وضعیت</label>
                                                    <select name="status" class="form-control" value={status} onChange={handleChangeInputs} style={{height: "40px"}} >
                                                        <option>فعال</option>
                                                        <option>غیر فعال</option>
                                                    </select>
                                                    <p class="text-danger"></p>
                                                </div>
                                            </Row>

                                        </div>
                                    </div>

                                    <div class="card-body collapse in">
                                        <div class="card-block">
                                            <div class="form-actions">
                                                <button type="submit" class="btn btn-success" name="add_btn" value="add" onClick={handleSubmitForm}>
                                                    <i class="icon-check2"></i> ثبت
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                </Collapse>

                            </div>
                        </Col>
                    </Row>





                </div>
            </div>
        </div>
    );
}

export default AddCourier;